import { Config } from '@backstage/config';

export const isAzurePolicyEnabled = (config: Config): boolean => {
  return config.getOptionalBoolean('platt.azurePolicy.enabled') ?? false;
};
